import { defineComponent as _defineComponent } from 'vue'
import { ref } from "../../../../adapter-vue";
import Icon from "../../../common/Icon.vue";
import BottomPopup from "../../../common/BottomPopup/index.vue";
import { isPC, isUniFrameWork } from "../../../../utils/env";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  iconFile: {
    type: String,
    required: true,
  },
  title: {
    type: String,
    default: "",
  },
  needDialog: {
    type: Boolean,
    default: true,
  },
  iconWidth: {
    type: String,
    default: "20px",
  },
  iconHeight: {
    type: String,
    default: "20px",
  },
  // 是否需要移动端底部弹窗对话框展示, 默认为false
  // pc端无效
  needBottomPopup: {
    type: Boolean,
    default: false,
  },
},
  emits: ["onIconClick", "onDialogClose", "onDialogShow"],
  setup(__props, { expose, emit: emits }) {

const props = __props





const showDialog = ref(false);
const toolbarItemRef = ref();
const dialogRef = ref();

const toggleToolbarItem = () => {
  emits("onIconClick", dialogRef);
  if (isPC) {
    onClickOutside(toolbarItemRef.value);
  }
  if (!props.needDialog) {
    return;
  }
  showDialog.value = true;
  emits("onDialogShow", dialogRef);
};

// click outside
let clickOutside = false;
let clickInner = false;
const onClickOutside = (component: any) => {
  if (isUniFrameWork) {
    return;
  }
  document.addEventListener("click", onClickDocument);
  component?.addEventListener &&
    component?.addEventListener("click", onClickTarget);
};

const onClickDocument = () => {
  clickOutside = true;
  if (!clickInner && clickOutside) {
    showDialog.value = false;
    removeClickListener(dialogRef.value);
    emits("onDialogClose", dialogRef);
  }
  clickOutside = false;
  clickInner = false;
};

const onClickTarget = () => {
  clickInner = true;
};

const removeClickListener = (component: any) => {
  if (isUniFrameWork) {
    return;
  }
  document.removeEventListener("click", onClickDocument);
  component?.removeEventListener &&
    component?.removeEventListener("click", onClickTarget);
};

const toggleDialogDisplay = (showStatus: boolean) => {
  showDialog.value = showStatus;
  switch (showStatus) {
    case true:
      emits("onDialogShow", dialogRef);
      break;
    case false:
      emits("onDialogClose", dialogRef);
  }
};

const onPopupClose = () => {
  showDialog.value = false;
};

expose({
  toggleDialogDisplay,
});

return { __sfc: true,props, emits, showDialog, toolbarItemRef, dialogRef, toggleToolbarItem, clickOutside, clickInner, onClickOutside, onClickDocument, onClickTarget, removeClickListener, toggleDialogDisplay, onPopupClose, Icon, BottomPopup, isPC, isUniFrameWork }
}

})